import client from './client';

export const dependenciesApi = {
  async list(projectKey) {
    const { data } = await client.get(`/api/projects/${projectKey}/dependencies`);
    return data;
  },

  async refresh(projectKey) {
    const { data } = await client.post(`/api/projects/${projectKey}/dependencies/refresh`);
    return data;
  },

  async getTransitive(projectKey, packageName) {
    const { data } = await client.get(`/api/projects/${projectKey}/dependencies/${encodeURIComponent(packageName)}/transitive`);
    return data;
  },

  async getLicenseReport(projectKey) {
    const { data } = await client.get(`/api/projects/${projectKey}/dependencies/license-report`);
    return data;
  },

  getLicenseReportCsvUrl(projectKey) {
    return `/api/projects/${projectKey}/dependencies/license-report?format=csv`;
  },
};
